// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';
import {Order} from './interfaces';

type Props = {
  ordersDispatch: any;
  data: Order[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({...props.filtersValues,page: undefined, size: 2000});
  };
  const flattData = (data: any) => {
    const newData = data.map(({
        customerLat,
        customerLon,
        receiptUrl,
        partnerId,
        fulfillmentWarehouseId,
        fulfillmentWarehouseAddress,
        ...item
      }: any) => {
      return {
          ...item,
          deliveryDateFa:
              item.deliveryDate &&
              jMoment(item.deliveryDate, "YYYY/M/D")
                  .locale("fa")
                  .format("jYY/jMM/jDD"),
          deliveryDate: item.deliveryDate,
          items: item.items?.map((item: any) => item.productName).join("& "),
          // items: item.items ? `${JSON.stringify(item?.items)?.replace(/['"]+/g, "'")}` : undefined,
          customerMobileNumber: item.customerMobileNumber + "",
          packages: undefined
      };
    });
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="Orders.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
